import { currentFlowState } from '@/state';
import { useUnwrappedAtomValue } from '@/state/loadableHooks';
import logger from '@/util/logger';
import { AppFlowDao, GuideDao } from '@rock/db-admin';
import type { AppFlowParams, GuideContext } from '@rock/types';
import { useState } from 'react';
import { toast } from 'sonner';

const log = logger('useRemovePublishedGuide');
const guideDao = new GuideDao();
const appFlowDao = new AppFlowDao();

export function useRemovePublishedGuide(params: AppFlowParams) {
    const [removing, setRemoving] = useState(false);
    const flow = useUnwrappedAtomValue(currentFlowState(params));
    const spaceId = flow?.space;
    const equipmentTypeId = flow?.equipmentTypeId;

    async function removePublishedGuide() {
        if (!flow || !spaceId) return;
        setRemoving(true);
        try {
            const context: GuideContext = equipmentTypeId
                ? { type: 'equipment', typeId: equipmentTypeId }
                : { type: 'space', spaceId };
            await guideDao.deleteGuide(context);
            await appFlowDao.deletePublishedFlow(spaceId, equipmentTypeId);
            toast.success('Removed Published Guide');
            log.info(`Removed published guide, space: ${spaceId}, equipment: ${equipmentTypeId}`);
        } catch (err) {
            toast.error('Error Removing Published Guide', { description: 'An unexpected error occurred.' });
            log.error('Error removing published guide', { err });
        } finally {
            setRemoving(false);
        }
    }

    return [removing, removePublishedGuide] as const;
}
